export default __webpack_public_path__ + "static/media/dark.2ba75ae6.png";